import { memo } from "react";
import { IGlobalNotification } from "@/common/services/types";
import RightImg from "./images/right-image.png";
import LeftImg from "./images/left-image.png";
import BatIcon from "./images/icons/bat.svg?react";
import "./InfoBar.scss";

interface IInfoBar {
  onLinkAction: (id: string) => void;
  onCloseInfoBar: (id: string) => void;
  notification: IGlobalNotification;
  showNotify: boolean;
}

export const InfoBar: React.FC<IInfoBar> = memo(({
  onLinkAction,
  notification,
  showNotify
}) => {
  const onLinkClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await onLinkAction(notification.id);
    location.href = notification.cta_link;
  };

  return (
    <div className={`InformationBar ${!showNotify ? "InformationBar_isHidden" : ""}`}>
      <div className="InformationBar-Wrap">
        <div className="InformationBar-LeftImg">
          <img src={LeftImg} />
        </div>
        <div className="InformationBar-LeftBat">
          <BatIcon />
        </div>
        <div className="InformationBar-Info">
          <p className="InformationBar-Text">{notification.text}</p>
          <button className="InformationBar-Link" rel="info-bar" onClick={onLinkClick}>{notification.cta_text}</button>
        </div>
        <div className="InformationBar-RightBats">
          <div className="BatsIcons">
            <BatIcon />
            <BatIcon />
          </div>
        </div>
        <div className="InformationBar-RightImg">
          <img src={RightImg} />
        </div>
      </div>
    </div>
  );
});
